<!-- dialog-elemente-add.component.html -->
<div class="dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-title">Element hinzufügen</h2>
    <button mat-icon-button (click)="onNoClick()" matTooltip="Schließen" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <mat-dialog-content class="dialog-content">
    <form #elementForm="ngForm">
      <!-- Grundinformationen -->
      <div class="section-title">
        <mat-icon>info</mat-icon>
        <span>Grundinformationen</span>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="data.newElement.name" name="name" required placeholder="Name des Elements">
          <mat-icon matSuffix>label</mat-icon>
          <mat-error *ngIf="elementForm.controls['name']?.invalid">Name ist erforderlich</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Beschreibung</mat-label>
          <textarea matInput [(ngModel)]="data.newElement.description" name="description" placeholder="Beschreibung des Elements" rows="1"></textarea>
          <mat-icon matSuffix>description</mat-icon>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Hersteller</mat-label>
          <input matInput [(ngModel)]="data.newElement.hersteller" name="hersteller" placeholder="Hersteller eingeben">
          <mat-icon matSuffix>business</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Bestellnummer</mat-label>
          <input matInput [(ngModel)]="data.newElement.bestellnumer" name="bestellnumer" placeholder="Bestellnummer eingeben">
          <mat-icon matSuffix>numbers</mat-icon>
        </mat-form-field>
      </div>

      <!-- Klassifikation -->
      <div class="section-title">
        <mat-icon>category</mat-icon>
        <span>Klassifikation</span>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Kategorie</mat-label>
          <mat-select [(ngModel)]="selectedCategory" name="kategorie" placeholder="Kategorie auswählen">
            <mat-option *ngFor="let category of data.categories" [value]="category">
              {{ category }}
            </mat-option>
            <mat-divider></mat-divider>
            <mat-option (click)="openAddCategoryDialog()" class="add-option">
              <mat-icon>add_circle</mat-icon> Neue Kategorie hinzufügen
            </mat-option>
          </mat-select>
          <mat-icon matSuffix>category</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Zustand</mat-label>
          <input matInput [(ngModel)]="data.newElement.zustand" name="zustand" placeholder="Zustand eingeben">
          <mat-icon matSuffix>health_and_safety</mat-icon>
        </mat-form-field>
      </div>

      <!-- Lagerinformationen -->
      <div class="section-title">
        <mat-icon>inventory</mat-icon>
        <span>Lagerinformationen</span>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Lager</mat-label>
          <mat-select [(ngModel)]="selectedLager" name="lager" placeholder="Lager auswählen" (selectionChange)="onLagerChanged()">
            <mat-option *ngFor="let lager of data.lager" [value]="lager">
              {{ lager }}
            </mat-option>
            <mat-divider></mat-divider>
            <mat-option (click)="openAddLagerDialog()" class="add-option">
              <mat-icon>add_circle</mat-icon> Neues Lager hinzufügen
            </mat-option>
          </mat-select>
          <mat-icon matSuffix>warehouse</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Lagerort</mat-label>
          <mat-select [(ngModel)]="selectedLagerort" name="lagerort" placeholder="Lagerort auswählen" [disabled]="!selectedLager">
            <mat-option *ngFor="let ort of lagerort" [value]="ort">
              {{ ort }}
            </mat-option>
            <mat-divider *ngIf="lagerort.length > 0"></mat-divider>
            <mat-option (click)="openAddLagerortDialog()" class="add-option" [disabled]="!selectedLager">
              <mat-icon>add_circle</mat-icon> Neuen Lagerort hinzufügen
            </mat-option>
          </mat-select>
          <mat-icon matSuffix>place</mat-icon>
        </mat-form-field>
      </div>

      <div class="form-row quantity-row">
        <mat-form-field appearance="outline" class="quantity-field">
          <mat-label>Menge</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="data.newElement.quantity" name="quantity" placeholder="Menge eingeben">
          <mat-icon matSuffix>inventory_2</mat-icon>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-divider></mat-divider>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()" class="cancel-button">
      <mat-icon>cancel</mat-icon> Abbrechen
    </button>
    <button mat-raised-button color="primary" (click)="onSaveClick()" [disabled]="!elementForm.form.valid">
      <mat-icon>save</mat-icon> Speichern
    </button>
  </mat-dialog-actions>
</div>
